import {
  ActivitiesAction,
  ADD_ACTIVITY,
  LOAD_ACTIVITIES,
  LOAD_ACTIVITIES_FAIL,
  LOAD_ACTIVITIES_SUCCESS,
  LoadActivitiesSuccess
} from '../actions/activities.action';
import {IActivity} from '../../activities/activity';
import {AddActivity, INIT_ACTIVITIES_SOCKET} from "../actions";

export interface IWebsiteActivitiesState {
  websiteId: number,
  entities: {[activityId: string]: IActivity}
}

export interface IActivitiesState {
  entities: {[websiteId: number]: IWebsiteActivitiesState},
  loading: boolean,
  loaded: boolean,
  toggled: boolean
}

export const initialState: IActivitiesState = {
  entities: {},
  loading: false,
  loaded: false,
  toggled: false
};

export function reducer(state: IActivitiesState = initialState, action: ActivitiesAction): IActivitiesState {
  let payload: any;

  switch (action.type) {

    case LOAD_ACTIVITIES:
      return {
        ...state,
        loading: true,
        loaded: false
      };

    case LOAD_ACTIVITIES_SUCCESS:
      payload = (<LoadActivitiesSuccess>action).payload;

      return {
        ...state,
        entities: payload,
        loading: false,
        loaded: true
      };

    case LOAD_ACTIVITIES_FAIL:
      return {
        ...state,
        loading: false,
        loaded: true
      };

    case INIT_ACTIVITIES_SOCKET:
      return state;

    case ADD_ACTIVITY:
      const addedActivity: IActivity = (<AddActivity>action).payload;

      return {
        ...state,
        entities: {
          ...state.entities,
          [addedActivity.websiteId]: {
            ...state.entities[addedActivity.websiteId],
            entities: {
              ...(state.entities[addedActivity.websiteId] ? state.entities[addedActivity.websiteId].entities : {}),
              [addedActivity.id]: addedActivity
            }
          }
        }
      };

  }

  return state;
}
